import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function LegalPage({ title, updatedAt, sections, relatedLinks = [] }) {
  return (
    <div className="legal-page-wrapper">
      <div className="legal-page-container">
        <header className="legal-page-header">
          <h1>{title}</h1>
          <p>Última atualização: {updatedAt}</p>
        </header>

        <main className="legal-page-content">
          {sections.map((section) => (
            <section key={section.heading} className="legal-page-section">
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </section>
          ))}
        </main>

        {relatedLinks.length > 0 && (
          <section className="legal-page-related">
            <h2>Veja também</h2>
            <ul>
              {relatedLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
}
